import React from 'react';
import { Spin } from 'antd';
import { useTheme } from '../../context/ThemeContext';
import { theme as antdTheme } from 'antd';

const PageLoader = () => {
  const { theme: currentTheme } = useTheme();
  const isDarkMode = currentTheme.algorithm?.[0] === antdTheme.darkAlgorithm;

  return (
    <div className="centerAbsolute" style={{
      background: isDarkMode ? '#141414' : '#ffffff',
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 1000
    }}>
      <Spin size="large" />
    </div>
  );
};

export default PageLoader;
